import React from 'react';
import find from 'lodash/find';
import get from 'lodash/get';
import InputItem from 'views/pages/ClientDetail/components/InputItem';
import {
  FormSection,
  ShouldUpdateWrapper,
} from 'views/pages/ClientDetail/components/Elements';
import { useOptions } from 'helper/hooks';
import ListSection from '../ListSection';

const Bankruptcies = ({ className, isEdit, form, data }) => {
  const { scBankruptcyStatusOptions } = useOptions();
  return (
    <ListSection
      className={className}
      isEdit={isEdit}
      form={form}
      data={data['bankruptcies'] || []}
      title="Bankruptcies"
      addBtnText="Add Bankruptcy"
      parentName="bankruptcies"
      fields={[
        {
          label: 'Bankruptcy Status',
          key: 'bankruptcy_status',
          type: 'value',
        },
        {
          label: 'Year',
          key: 'year',
          type: 'value',
        },
        {
          label: 'Other',
          key: 'other',
          type: 'value',
          dependField: 'bankruptcy_status',
          dependFn: val => val !== 'Other',
        },
      ]}
      renderEditForm={index => {
        return (
          <FormSection>
            <InputItem
              name={[index, 'bankruptcy_status_id']}
              label="Bankruptcy Status"
              form={form}
              type="select"
              options={scBankruptcyStatusOptions}
            />
            <InputItem
              name={[index, 'year']}
              label="Year"
              form={form}
              placeholder="Enter year"
              addressGroupField
            />
            <InputItem
              name={[index, 'fake']}
              label="Fake"
              form={form}
              addressGroupField
              fake
            />
            <ShouldUpdateWrapper>
              {() => {
                const values = form.getFieldsValue();
                const valueObj = get(values, `bankruptcies[${index}]`) || {};
                const foundType =
                  find(scBankruptcyStatusOptions, {
                    value: valueObj.bankruptcy_status_id,
                  }) || {};
                if (foundType.label !== 'Other') {
                  return <></>;
                }
                return (
                  <>
                    <InputItem
                      name={[index, 'other']}
                      label="Other"
                      form={form}
                    />
                  </>
                );
              }}
            </ShouldUpdateWrapper>
          </FormSection>
        );
      }}
    />
  );
};

export default Bankruptcies;
